import { Base } from '../base-component';

import './hero-banner-item-col.component.scss';
import { MediaQueryService } from '../../services/media-query.service';

export class HeroBannerItemCol extends Base {

	w: number;
	h: number;
	ratio: number;
	imageHolder: HTMLElement;
	contentBackground: HTMLElement;
	desktopImages: HTMLElement[];
	tabletImages: HTMLElement[];
	mobileImages: HTMLElement[];

	constructor(element: Element) {
		super(element);
		this.w = 1200;
		this.h = 480; // initial height of the image
		this.ratio = this.w / this.h;
	}

	init() {
		this.imageHolder = this.element.querySelector('.hero-banner-item-col__image-holder') as HTMLElement;

		this.desktopImages = Array.from(this.element.querySelectorAll('.hero-banner-item-col__col-image__desktop'));
		this.tabletImages = Array.from(this.element.querySelectorAll('.hero-banner-item-col__col-image__tablet'));
		this.mobileImages = Array.from(this.element.querySelectorAll('.hero-banner-item-col__col-image__mobile'));

		this.contentBackground = this.element.querySelector('.hero-banner-item-col__content-background') as HTMLElement;
		setTimeout(this.onResize.bind(this));
	}

	bindEvents() {
		window.addEventListener('resize', this.onResize.bind(this));
	}

	onResize() {

		if (MediaQueryService.getMediaQuery() === 'small' || MediaQueryService.getMediaQuery() === 'x-small') {

			this.desktopImages.map((item) => {
				item.classList.remove('hero-banner-item-col__col-image__show');
				item.classList.add('hero-banner-item-col__col-image__hidden');
			});
			this.tabletImages.map((item) => {
				item.classList.remove('hero-banner-item-col__col-image__show');
				item.classList.add('hero-banner-item-col__col-image__hidden');
			});
			this.mobileImages.map((item) => {
				item.classList.remove('hero-banner-item-col__col-image__hidden');
				item.classList.add('hero-banner-item-col__col-image__show');
			});

		} else if (MediaQueryService.getMediaQuery() === 'medium-small' || MediaQueryService.getMediaQuery() === 'medium' || MediaQueryService.getMediaQuery() === 'large') {

			this.desktopImages.map((item) => {
				item.classList.remove('hero-banner-item-col__col-image__show');
				item.classList.add('hero-banner-item-col__col-image__hidden');
			});
			this.tabletImages.map((item) => {
				item.classList.remove('hero-banner-item-col__col-image__hidden');
				item.classList.add('hero-banner-item-col__col-image__show');
			});
			this.mobileImages.map((item) => {
				item.classList.remove('hero-banner-item-col__col-image__show');
				item.classList.add('hero-banner-item-col__col-image__hidden');
			});

		} else {

			this.desktopImages.map((item) => {
				item.classList.remove('hero-banner-item-col__col-image__hidden');
				item.classList.add('hero-banner-item-col__col-image__show');
			});
			this.tabletImages.map((item) => {
				item.classList.remove('hero-banner-item-col__col-image__show');
				item.classList.add('hero-banner-item-col__col-image__hidden');
			});
			this.mobileImages.map((item) => {
				item.classList.remove('hero-banner-item-col__col-image__show');
				item.classList.add('hero-banner-item-col__col-image__hidden');
			});

		}

		const ww = window.innerWidth;

		const el = this.element as HTMLElement;
		el.style.opacity = '1';

		if (ww > this.w) {

			const bannerHeight = ww / this.ratio;
			const colWidth = this.w / 12;
			const cbWidth = ((ww - (12 * colWidth)) / 2) + (4 * colWidth);

			// this.imageHolder.style.height = bannerHeight + 'px';
			// this.contentBackground.style.width = cbWidth + 'px';
			// this.contentBackground.style.height = bannerHeight + 'px';

		} else {

			this.contentBackground.style.removeProperty('height');

			if (MediaQueryService.getMediaQuery() === 'x-small') {

				this.contentBackground.style.width = '100%';
				this.imageHolder.style.height = '122px';

			}
			else if (MediaQueryService.getMediaQuery() === 'small') {

				this.contentBackground.style.width = '100%';
				this.imageHolder.style.height = '250px';

			} else if (MediaQueryService.getMediaQuery() === 'medium') {

				this.imageHolder.style.removeProperty('height');
				const colWidth = ww / 12;
				this.contentBackground.style.width = (5 * colWidth) + 'px';

			} else {

				this.imageHolder.style.removeProperty('height');
				const colWidth = ww / 12;
				this.contentBackground.style.width = (4 * colWidth) + 'px';

			}

		}

	}

}



// WEBPACK FOOTER //
// ./components/hero-banner-item-col/hero-banner-item-col.component.ts